import { getFunctions, httpsCallable } from 'firebase/functions';
import firebaseApp from '../../../../util/firebase';

const functions = getFunctions(firebaseApp);
const sheetInfo = httpsCallable(functions, 'ILCPExternalGetSheetInfo');

const getSheetInfo = async (data) => (await sheetInfo(data)).data;

export default getSheetInfo;
